export const getColumnDefs = () => [
  {
    field: '',
    headerName: '',
    maxWidth: 50,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  },
  {
    headerName: 'Depots',
    field: 'depot',
    initialHide: true,
    rowGroup: true,
  },
  {
    headerName: 'Drivers',
    field: 'driver',
  },
]
